export type ThemeColorGroupName =
  'primary' | 'secondary' | 'info' | 'success' | 'warning' | 'error' | 'gray';

/**
 * Semantic colours that carry a full main/soft/softer + opacity ramp — excludes
 * `gray`, which only defines a `main` shade. Use this where a component needs
 * the whole tonal range (e.g. BMIconCircle).
 */
export type SemanticColorGroupName = Exclude<ThemeColorGroupName, 'gray'>;

export enum ThemeName {
  light = 'light',
  dark = 'dark'
}

export type ColorVariantKey =
  | '0'
  | '10'
  | '25'
  | '50'
  | '75'
  | '100'
  | '200'
  | '300'
  | '400'
  | '500'
  | '600'
  | '700'
  | '800'
  | '900'
  | '1000'
  | '1200';

export type ColorVariants = {
  [key in ColorVariantKey]: string; // e.g., '50': "#e9ecfe"
};
export type ShadeName = 'darker' | 'dark' | 'main' | 'soft' | 'softer';

export type ColorShades = {
  [K in ShadeName]: ColorVariantKey; // e.g., 'main': 500
};

export interface SingleColor {
  shades: Pick<ColorShades, 'main'> & Partial<Omit<ColorShades, 'main'>>;
  variants: Partial<ColorVariants>;
}

export type ThemeColorSet = Record<ThemeColorGroupName, SingleColor>;

export type ColorPalette = {
  [theme in ThemeName]: ThemeColorSet;
};

export type VariantExample = {
  variant: ColorVariantKey;
  hexValue: string;
};

export type VuetifyShadeKey = ShadeName | '';

export type ThemeConfigShades = Partial<
  Record<VuetifyShadeKey, VariantExample>
>;

export type ThemeGroupExample = {
  name: ThemeColorGroupName;
  variants: Partial<Record<ColorVariantKey, string>>;
  shades: ThemeConfigShades;
};

// Huge Icon Types
export type IconSvgObject = Array<[string, { [key: string]: string }]>;

export type ComponentVariant = 'plain' | 'flat' | 'tonal' | 'text' | 'outlined';
